import { render, staticRenderFns } from "./gallery_foto.vue?vue&type=template&id=738a666b&"
import script from "./gallery_foto.vue?vue&type=script&lang=js&"
export * from "./gallery_foto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports